export function SimpleEntrypointBoxConstructor(services, type, context, siteTypeConfig) {

  const joint = services.joint;
  let label;
  switch (type) {
    case 'html.GetStartedBox':
      if (context.site.type_name === 'line') {
        label = services.$translate.instant('parameters/quick_replies/details/graph/become_friends_box_title_in_diagram');
      } else {
        label = services.$translate.instant('parameters/quick_replies/details/graph/get_started_box_title_in_diagram');
      }
      break;
    case 'html.SurveyStartedBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/survey_started_box_title_in_diagram');
      break;
    case 'html.NewConversationBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/new_conversation_box_title_in_diagram');
      break;
    case 'html.UnexpectedUserInputBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/unexpected_user_input_box_title_in_diagram');
      break;
    case 'html.AgentShortcutBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/agent_shortcut_box_title_in_diagram');
      break;
    case 'html.MassMessagingEntryPointBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/mass_messaging_box_title_in_diagram');
      break;
    case 'html.FirstConversationEverBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/first_conversation_ever_box_title_in_diagram');
      break;
    case 'html.FollowingConversationsBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/following_conversations_box_title_in_diagram');
      break;
    case 'html.WhatsappCartSentBox':
      label = services.$translate.instant('parameters/quick_replies/details/graph/whatsapp_cart_sent_box_title_in_diagram');
      break;
  }

  const defaults = joint.util.deepSupplement({
    'labelText': label,
    'labelFill': '#000',
    'type': type,
  }, joint.shapes.html.AbstractBox.prototype.defaults);


  return joint.shapes.html.AbstractBox.extend({
    'defaults': defaults
  });

}
